import {
    TECH_DOC_INTERNAL_GENERATED_PRESIGNED_URLS,
    TECH_DOC_INTERNAL_TICKET_ATTACHMENTS_SAVED_ERROR, TECH_DOC_INTERNAL_TICKET_ATTACHMENTS_SAVED,
} from '../../constants/websocketCommands';
import {
    TECH_DOC_INTERNAL_TICKET_ATTACHMENTS_UPLOADING,
    TECH_DOC_INTERNAL_TICKET_ATTACHMENTS_UPLOADING_ERROR
} from '../../actions/techDoc/actionTechDocInternalTicketAttachments';
import {TECH_DOC_INTERNAL_TICKET_RESET} from '../../actions/techDoc/actionTechDocInternalTicket';

export const techDocInternalTicketAttachment = (state = {
    correlationId: null,
    isTicketAttachmentUploading: false,
    attachmentsForUpload: [],
}, action) => {
    switch (action.type) {
        case TECH_DOC_INTERNAL_TICKET_RESET: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        case TECH_DOC_INTERNAL_GENERATED_PRESIGNED_URLS: {
            const {attachments} = action.payload;
            return Object.assign({}, state, {
                attachmentsForUpload: Array.isArray(attachments) ? attachments : [],
            });
        }
        case TECH_DOC_INTERNAL_TICKET_ATTACHMENTS_UPLOADING: {
            return Object.assign({}, state, {isTicketAttachmentUploading: true});
        }
        //att done + error
        case TECH_DOC_INTERNAL_TICKET_ATTACHMENTS_SAVED_ERROR:
        case TECH_DOC_INTERNAL_TICKET_ATTACHMENTS_UPLOADING_ERROR: {
            return Object.assign({}, state, {
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        case TECH_DOC_INTERNAL_TICKET_ATTACHMENTS_SAVED: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId,
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        default:
            return state;
    }
};
